import { createSlice } from "@reduxjs/toolkit";

const initialUIState = {
  userParamName: "",
  userDBId: "",
};

const uiSlice = createSlice({
  name: "ui",
  initialState: initialUIState,
  reducers: {
    changeUserDBId(state, action) {
      state.userDBId = action.payload.userDBId;
    },
    changeUserParamName(state, action){
      state.userParamName = action.payload.userParamName
    },
  },
});

export const uiActions = uiSlice.actions;

export default uiSlice;